import { type TFunction } from "i18next";
import { z } from "zod";

export const interruptSchema = (t: TFunction) =>
  z.object({
    files: z.any().optional(),
    internalNotes: z
      .string()
      .max(
        1000,
        t("form-validation.max-length", {
          label: t("vessel-call.common.internal-notes"),
          max: 1000,
        }),
      )
      .optional(),
    externalNotes: z
      .string({
        required_error: t("form-validation.mandatory", {
          label: t("vessel-call.common.external-notes"),
        }),
      })
      .min(1, {
        message: t("form-validation.mandatory", {
          label: t("vessel-call.common.external-notes"),
        }),
      })
      .max(
        1000,
        t("form-validation.max-length", {
          label: t("vessel-call.common.external-notes"),
          max: 1000,
        }),
      ),
    forceLeave: z.boolean({
      required_error: t("form-validation.mandatory", {
        label: t("vessel-call.interrupt.force-leave"),
      }),
      invalid_type_error: t("form-validation.mandatory", {
        label: t("vessel-call.interrupt.force-leave"),
      }),
    }),
  });

export type InterruptSchema = z.infer<ReturnType<typeof interruptSchema>>;
